<template>
  <div class="timeline-item container-item" data-scroll="scroll">    
      <div class="row">
        <div class="col-12 p-0">
          <div v-if="!cardText[0].text" class="pr-3 pl-3" :class="cardText[0].position">
            <span class="line"></span>
            <h3 v-if="cardText[0].year">{{ cardText[0].year }}</h3>
          </div>
          <div v-for="(i, ix) in cardText" :key="ix" class="timeline-media">
            <img :src="i.imageBg" :class="cardText[0].position"/>
            <div v-if="i.imageCredits" class="creditos-picture" :class="cardText[0].position">
              {{ $t('creditos.label_creditos') }}: {{ i.imageCredits }}
            </div>
          </div>          
          <div v-if="cardText[0].text" class="timeline-content dark" :class="cardText[0].position">
            <span class="line"></span>
            <h3 v-if="cardText[0].year">{{ cardText[0].year }}</h3>
            <p>
              {{ cardText[0].text }}
            </p>
          </div>
        </div>
      </div>    
  </div>
</template>

<script>


export default {
  name: 'ScrollText',
  props: {
    cardText: Array
  }
}
</script>
